import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {SupplierReportSelectionData} from "../../supplier/controls/supplier-report-selection-control.component";

export class InvoiceSummaryReportData extends ReportData<InvoiceSummaryReportData> {
    @field summary: boolean = false;

    @field invoiceDateRangeSubType: string = "Invoice Date";
    @field includeCreditInvoices: boolean = true;

    @collection(SupplierReportSelectionData) suppliers: SupplierReportSelectionData[];
}
